export class WFMComponent {
  static debounce(func, interval, ctx?) {
    let timeout;
    return function (...args: any[]) {
      const context = ctx ? ctx : this;
      const later = () => {
        timeout = null;
        func.apply(context, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, interval || 200);
    };
  }
}
